import { IActivityHistoryCustomFilterGroup } from "../../filter";
import { IActivityHistoryItem } from "../model";
import { FalseSpec } from "./false-spec";
import { Spec } from "./spec";

export class TypeSpec extends Spec<IActivityHistoryItem> {
  constructor(public itemType: string) {
    super();
  }
  isSatisfiedBy(context: IActivityHistoryItem): boolean {
    return context?.type === this.itemType;
  }
}

export class ComposedTypeSpec extends Spec<IActivityHistoryItem> {
  constructor(public filters: IActivityHistoryCustomFilterGroup[]) {
    super();
  }
  isSatisfiedBy(item: IActivityHistoryItem): boolean {
    const enabledGroupTypes = this.filters.filter((f) => f.enabled).map((f) => f.id);

    // Si no hay filtros de tipo habilitados, aceptar todos los items
    if (enabledGroupTypes.length === 0) {
      return true;
    }

    const finalSpec = enabledGroupTypes.reduce((acc, groupId) => {
      return acc.or(new TypeSpec(groupId));
    }, new FalseSpec());
    return finalSpec.isSatisfiedBy(item);
  }
}
